/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AdminFeedbackExportCsvGetV2Params,
  AdminFeedbackListGetV2Params,
  BadRequestResponse,
  FeedbackPageDto,
  ForbiddenResponse,
  GenerateStoryAnalysis,
  GenerateStoryAnalyzeRequest,
  GenerateStoryConfirmApiRequest,
  GenerateStoryConfirmResponse,
  SubmitFeedbackRequest,
  SubmitMobileFeedbackRequest,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const feedbackSubmitPostV2 = (
  submitFeedbackRequest: BodyType<SubmitFeedbackRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Feedback/submit`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: submitFeedbackRequest,
      signal,
    },
    options,
  );
};

export const getFeedbackSubmitPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof feedbackSubmitPostV2>>,
    TError,
    { data: BodyType<SubmitFeedbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof feedbackSubmitPostV2>>,
  TError,
  { data: BodyType<SubmitFeedbackRequest> },
  TContext
> => {
  const mutationKey = ["feedbackSubmitPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof feedbackSubmitPostV2>>,
    { data: BodyType<SubmitFeedbackRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return feedbackSubmitPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FeedbackSubmitPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof feedbackSubmitPostV2>>
>;
export type FeedbackSubmitPostV2MutationBody = BodyType<SubmitFeedbackRequest>;
export type FeedbackSubmitPostV2MutationError = ErrorType<BadRequestResponse>;

export const useFeedbackSubmitPostV2 = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof feedbackSubmitPostV2>>,
    TError,
    { data: BodyType<SubmitFeedbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof feedbackSubmitPostV2>>,
  TError,
  { data: BodyType<SubmitFeedbackRequest> },
  TContext
> => {
  const mutationOptions = getFeedbackSubmitPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const feedbackMobilePostV2 = (
  submitMobileFeedbackRequest: BodyType<SubmitMobileFeedbackRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Feedback/mobile`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: submitMobileFeedbackRequest,
      signal,
    },
    options,
  );
};

export const getFeedbackMobilePostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof feedbackMobilePostV2>>,
    TError,
    { data: BodyType<SubmitMobileFeedbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof feedbackMobilePostV2>>,
  TError,
  { data: BodyType<SubmitMobileFeedbackRequest> },
  TContext
> => {
  const mutationKey = ["feedbackMobilePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof feedbackMobilePostV2>>,
    { data: BodyType<SubmitMobileFeedbackRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return feedbackMobilePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FeedbackMobilePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof feedbackMobilePostV2>>
>;
export type FeedbackMobilePostV2MutationBody =
  BodyType<SubmitMobileFeedbackRequest>;
export type FeedbackMobilePostV2MutationError = ErrorType<BadRequestResponse>;

export const useFeedbackMobilePostV2 = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof feedbackMobilePostV2>>,
    TError,
    { data: BodyType<SubmitMobileFeedbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof feedbackMobilePostV2>>,
  TError,
  { data: BodyType<SubmitMobileFeedbackRequest> },
  TContext
> => {
  const mutationOptions = getFeedbackMobilePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 */
export const adminFeedbackListGetV2 = (
  params?: AdminFeedbackListGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<FeedbackPageDto>(
    { url: `/apix/v2/admin/Feedback/list`, method: "GET", params, signal },
    options,
  );
};

export const getAdminFeedbackListGetV2QueryKey = (
  params?: AdminFeedbackListGetV2Params,
) => {
  return [`/apix/v2/admin/Feedback/list`, ...(params ? [params] : [])] as const;
};

export const getAdminFeedbackListGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminFeedbackListGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: AdminFeedbackListGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminFeedbackListGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminFeedbackListGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminFeedbackListGetV2>>
  > = ({ signal }) => adminFeedbackListGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminFeedbackListGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminFeedbackListGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminFeedbackListGetV2>>
>;
export type AdminFeedbackListGetV2QueryError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

export function useAdminFeedbackListGetV2<
  TData = Awaited<ReturnType<typeof adminFeedbackListGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: AdminFeedbackListGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminFeedbackListGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminFeedbackListGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 */
export const adminFeedbackFeedbackIdsGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<string[]>(
    { url: `/apix/v2/admin/Feedback/feedback-ids`, method: "GET", signal },
    options,
  );
};

export const getAdminFeedbackFeedbackIdsGetV2QueryKey = () => {
  return [`/apix/v2/admin/Feedback/feedback-ids`] as const;
};

export const getAdminFeedbackFeedbackIdsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminFeedbackFeedbackIdsGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminFeedbackFeedbackIdsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminFeedbackFeedbackIdsGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminFeedbackFeedbackIdsGetV2>>
  > = ({ signal }) => adminFeedbackFeedbackIdsGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminFeedbackFeedbackIdsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminFeedbackFeedbackIdsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminFeedbackFeedbackIdsGetV2>>
>;
export type AdminFeedbackFeedbackIdsGetV2QueryError =
  ErrorType<ForbiddenResponse>;

export function useAdminFeedbackFeedbackIdsGetV2<
  TData = Awaited<ReturnType<typeof adminFeedbackFeedbackIdsGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminFeedbackFeedbackIdsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminFeedbackFeedbackIdsGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 */
export const adminFeedbackExportCsvGetV2 = (
  params?: AdminFeedbackExportCsvGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/admin/Feedback/export-csv`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getAdminFeedbackExportCsvGetV2QueryKey = (
  params?: AdminFeedbackExportCsvGetV2Params,
) => {
  return [
    `/apix/v2/admin/Feedback/export-csv`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminFeedbackExportCsvGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminFeedbackExportCsvGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  params?: AdminFeedbackExportCsvGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminFeedbackExportCsvGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminFeedbackExportCsvGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminFeedbackExportCsvGetV2>>
  > = ({ signal }) =>
    adminFeedbackExportCsvGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminFeedbackExportCsvGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminFeedbackExportCsvGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminFeedbackExportCsvGetV2>>
>;
export type AdminFeedbackExportCsvGetV2QueryError =
  ErrorType<ForbiddenResponse>;

export function useAdminFeedbackExportCsvGetV2<
  TData = Awaited<ReturnType<typeof adminFeedbackExportCsvGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  params?: AdminFeedbackExportCsvGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminFeedbackExportCsvGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminFeedbackExportCsvGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 */
export const adminFeedbackGenerateStoryAnalyzePostV2 = (
  generateStoryAnalyzeRequest: BodyType<GenerateStoryAnalyzeRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GenerateStoryAnalysis>(
    {
      url: `/apix/v2/admin/Feedback/generate-story/analyze`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: generateStoryAnalyzeRequest,
      signal,
    },
    options,
  );
};

export const getAdminFeedbackGenerateStoryAnalyzePostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminFeedbackGenerateStoryAnalyzePostV2>>,
    TError,
    { data: BodyType<GenerateStoryAnalyzeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminFeedbackGenerateStoryAnalyzePostV2>>,
  TError,
  { data: BodyType<GenerateStoryAnalyzeRequest> },
  TContext
> => {
  const mutationKey = ["adminFeedbackGenerateStoryAnalyzePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminFeedbackGenerateStoryAnalyzePostV2>>,
    { data: BodyType<GenerateStoryAnalyzeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminFeedbackGenerateStoryAnalyzePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminFeedbackGenerateStoryAnalyzePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminFeedbackGenerateStoryAnalyzePostV2>>
>;
export type AdminFeedbackGenerateStoryAnalyzePostV2MutationBody =
  BodyType<GenerateStoryAnalyzeRequest>;
export type AdminFeedbackGenerateStoryAnalyzePostV2MutationError =
  ErrorType<BadRequestResponse>;

export const useAdminFeedbackGenerateStoryAnalyzePostV2 = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminFeedbackGenerateStoryAnalyzePostV2>>,
    TError,
    { data: BodyType<GenerateStoryAnalyzeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminFeedbackGenerateStoryAnalyzePostV2>>,
  TError,
  { data: BodyType<GenerateStoryAnalyzeRequest> },
  TContext
> => {
  const mutationOptions =
    getAdminFeedbackGenerateStoryAnalyzePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 */
export const adminFeedbackGenerateStoryConfirmPostV2 = (
  generateStoryConfirmApiRequest: BodyType<GenerateStoryConfirmApiRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GenerateStoryConfirmResponse>(
    {
      url: `/apix/v2/admin/Feedback/generate-story/confirm`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: generateStoryConfirmApiRequest,
      signal,
    },
    options,
  );
};

export const getAdminFeedbackGenerateStoryConfirmPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminFeedbackGenerateStoryConfirmPostV2>>,
    TError,
    { data: BodyType<GenerateStoryConfirmApiRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminFeedbackGenerateStoryConfirmPostV2>>,
  TError,
  { data: BodyType<GenerateStoryConfirmApiRequest> },
  TContext
> => {
  const mutationKey = ["adminFeedbackGenerateStoryConfirmPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminFeedbackGenerateStoryConfirmPostV2>>,
    { data: BodyType<GenerateStoryConfirmApiRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminFeedbackGenerateStoryConfirmPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminFeedbackGenerateStoryConfirmPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminFeedbackGenerateStoryConfirmPostV2>>
>;
export type AdminFeedbackGenerateStoryConfirmPostV2MutationBody =
  BodyType<GenerateStoryConfirmApiRequest>;
export type AdminFeedbackGenerateStoryConfirmPostV2MutationError =
  ErrorType<BadRequestResponse | void>;

export const useAdminFeedbackGenerateStoryConfirmPostV2 = <
  TError = ErrorType<BadRequestResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminFeedbackGenerateStoryConfirmPostV2>>,
    TError,
    { data: BodyType<GenerateStoryConfirmApiRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminFeedbackGenerateStoryConfirmPostV2>>,
  TError,
  { data: BodyType<GenerateStoryConfirmApiRequest> },
  TContext
> => {
  const mutationOptions =
    getAdminFeedbackGenerateStoryConfirmPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
